import type { Channel } from "@/types/content";

export const channels: Channel[] = [
  {
    slug: "industry",
    name: "行业内幕",
    tagline: "拆解套路与潜规则",
    description:
      "把常见行业的运作方式、话术结构与灰色地带拆开来看。这一栏目关注信息差是如何被制造出来的，以及普通人在其中最容易吃亏的环节。",
    icon: "ri-scales-3-line",
    tone: "primary",
  },
  {
    slug: "business",
    name: "商业暗流",
    tagline: "资本与博弈的幕后",
    description:
      "从并购、渠道、定价到供应链，梳理商业世界里不写在新闻稿里的部分。用公开信息还原一场博弈中各方的动机与筹码。",
    icon: "ri-line-chart-line",
    tone: "accent",
  },
  {
    slug: "city",
    name: "都市奇谈",
    tagline: "城市里的隐秘细节",
    description:
      "每座城市都有自己的暗面故事。这一栏目记录街巷、老楼与夜间行业里那些很少被正式提起，却真实影响过很多人的细节。",
    icon: "ri-building-2-line",
    tone: "secondary",
  },
  {
    slug: "internet",
    name: "网络迷雾",
    tagline: "热点背后的真相梳理",
    description:
      "一条内容从发生到冲上热榜，中间经过了谁、经过了什么。这一栏目把流量事件的完整链路还原出来，帮读者分辨情绪与事实。",
    icon: "ri-signal-tower-line",
    tone: "primary",
  },
  {
    slug: "history",
    name: "历史暗影",
    tagline: "被忽略的历史碎片",
    description:
      "旧账本、老照片、停产的票据，都是历史的另一种写法。这一栏目从细节里翻出被时间掩埋的片段，重新拼接成可读的叙事。",
    icon: "ri-ancient-gate-line",
    tone: "accent",
  },
  {
    slug: "people",
    name: "人物观察",
    tagline: "聚光灯之外的转身",
    description:
      "公众人物的高光时刻常被反复书写，而沉默的那段时间几乎无人提及。这一栏目关注转身、退场与重新出发的完整过程。",
    icon: "ri-user-search-line",
    tone: "secondary",
  },
];

export const getChannel = (slug: string): Channel | undefined =>
  channels.find((c) => c.slug === slug);